import { AlphabetGreekIcon } from './AlphabetGreekIcon';

/**
 * author: Haley Halcyon
 * id 5E1EDFBD-2E67-41E1-8E23-F835614DBBD9
 * name alphabet-greek
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alphabet-greek.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemGreekIcon = AlphabetGreekIcon;
export default WritingSystemGreekIcon